module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-authorizelm"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-basic-container"
  }, [_c('div', {
    staticClass: "authorizelm-text"
  }, [_vm._v("授权功能说明： 针对指定对象进行审批权限的授权，本人失去原有审批权限，可以在授权页面查看和维护授权功能，无法针对多个用户进行重复授权。")]), _vm._v(" "), _c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "header-cell-class-name": "table-header-cell",
      "tooltip-effect": "light"
    }
  }, [(_vm.isAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "licensorAd",
      "label": "授权人AD"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "licensorName",
      "label": "授权人姓名"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonAd",
      "label": "被授权人AD"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonName",
      "label": "被授权人姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonEmail",
      "label": "被授权人邮箱"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizationDeadline",
      "label": "授权截至日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "终止授权"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                          终止\n                      ")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmDeleteVisible,
      "confirm": _vm.handlerDeleteConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmDeleteVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmDeleteVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n        是否确认取消授权?\n      ")])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4628556a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4628556a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/user/authorizelm/index.vue
// module id = 1571
// module chunks = 7